export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';

// Calendar Periods Actions
export const CREATE_PERIOD_DEFINITION_START = 'CREATE_PERIOD_DEFINITION_START';
export const CREATE_PERIOD_DEFINITION_SUCCESS = 'CREATE_PERIOD_DEFINITION_SUCCESS';
export const CREATE_PERIOD_DEFINITION_FAIL = 'CREATE_PERIOD_DEFINITION_FAIL';

export const GET_PERIODS_START = 'GET_PERIODS_START';
export const GET_PERIODS_SUCCESS = 'GET_PERIODS_SUCCESS';
export const GET_PERIODS_FAIL = 'GET_PERIODS_FAIL';

export const GET_PERIOD_BY_ID_START = 'GET_PERIOD_BY_ID_START';
export const GET_PERIOD_BY_ID_SUCCESS = 'GET_PERIOD_BY_ID_SUCCESS';
export const GET_PERIOD_BY_ID_FAIL = 'GET_PERIOD_BY_ID_FAIL';

export const UPDATE_PERIOD_START = 'UPDATE_PERIOD_START';
export const UPDATE_PERIOD_SUCCESS = 'UPDATE_PERIOD_SUCCESS';
export const UPDATE_PERIOD_FAIL = 'UPDATE_PERIOD_FAIL';

export const DELETE_PERIOD_START = 'DELETE_PERIOD_START';
export const DELETE_PERIOD_SUCCESS = 'DELETE_PERIOD_SUCCESS';
export const DELETE_PERIOD_FAIL = 'DELETE_PERIOD_FAIL';

export const GENERATE_PERIODS_START = 'GENERATE_PERIODS_START';
export const GENERATE_PERIODS_SUCCESS = 'GENERATE_PERIODS_SUCCESS';
export const GENERATE_PERIODS_FAIL = 'GENERATE_PERIODS_FAIL';

export const GET_PERIODS_BY_NAME_YEAR_START = 'GET_PERIODS_BY_NAME_YEAR_START';
export const GET_PERIODS_BY_NAME_YEAR_SUCCESS = 'GET_PERIODS_BY_NAME_YEAR_SUCCESS';
export const GET_PERIODS_BY_NAME_YEAR_FAIL = 'GET_PERIODS_BY_NAME_YEAR_FAIL';

export const CLEAR_SELECTED_PERIOD = 'CLEAR_SELECTED_PERIOD';

